import React from 'react'

export default (props) => {
  console.log(props)
  const content = () => {
    return (
      <div>
        hello
      </div>
    )
  }
  return(
    <div data-c="PageSingle">
      {content()}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/posts/PostSingle.js